// @flow
import type { PriceParams } from "common/records/Price"

type MandatorySeatingType = {|
  price: PriceParams,
  segment_code: string,
|}

const setMandatorySeating = (
  mandatorySeating: Array<MandatorySeatingType>,
): { type: string, payload: { mandatorySeating: Array<MandatorySeatingType> } } => ({
  type: "SET_MANDATORY_SEATING",
  payload: { mandatorySeating },
})

export default setMandatorySeating
